'use strict';

import firebase from "firebase/app";

export default {
  state: {
    rates: {},
    fiatRates: {},
    commissionRates: {},
  },
  getters: {
    commissionRates: (state) => {
      return state.rates;
    },
    fiatRates: (state) => {
      return state.fiatRates;
    },
  },
  mutations: {
    updateСommissionRates(state, rates) {
      state.rates = rates;
    },
    updateFiatRates(state, fiatRates) {
      state.fiatRates = fiatRates;
    },
  },
  actions: {
    async getСommissionRates({ commit }) {
      await firebase
        .firestore()
        .collection("settings")
        .doc("commission-rates")
        .get()
        .then((doc) => {
          commit("updateСommissionRates", doc.data());
        });
    },
    async getFiatRates({ commit }) {
      await firebase
        .firestore()
        .collection("settings")
        .doc("fiat-rates")
        .get()
        .then((doc) => {
          commit("updateFiatRates", doc.data());
        });
    },
    async changeСommissionRates({ dispatch }, { BTC, ETH, USDT, USD, EUR, UAH }) {
      dispatch;
      await firebase
        .firestore()
        .collection("settings")
        .doc("commission-rates")
        .update({
          BTC: {
            buy: BTC.buy.toFixed(3),
            sell: BTC.sell.toFixed(3),
          },
          ETH: {
            buy: ETH.buy.toFixed(3),
            sell: ETH.sell.toFixed(3),
          },
          USDT: {
            buy: USDT.buy.toFixed(3),
            sell: USDT.sell.toFixed(3),
          },
          USD: {
            buy: USD.buy.toFixed(3),
            sell: USD.sell.toFixed(3),
          },
          EUR: {
            buy: EUR.buy.toFixed(3),
            sell: EUR.sell.toFixed(3),
          },
          UAH: {
            buy: UAH.buy.toFixed(3),
            sell: UAH.sell.toFixed(3),
          },
        })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    async changeFiatRates({ dispatch }, { USD }) {
      dispatch;
      await firebase
        .firestore()
        .collection("settings")
        .doc("fiat-rates")
        .update({
          USD: {
            EUR: {
              buy: USD.EUR.buy.toFixed(3),
              sell: USD.EUR.sell.toFixed(3)
            },
            UAH: {
              buy: USD.UAH.buy.toFixed(3),
              sell: USD.UAH.sell.toFixed(3)
            }
          },
          EUR: {
            USD: {
              buy: (1 / USD.EUR.buy).toFixed(3),
              sell: (1 / USD.EUR.sell).toFixed(3)
            },
            UAH: {
              buy: (USD.UAH.buy / USD.EUR.buy).toFixed(3),
              sell: (USD.UAH.sell / USD.EUR.sell).toFixed(3)
            }
          },
          UAH: {
            USD: {
              buy: (1 / USD.UAH.buy).toFixed(3),
              sell: (1 / USD.UAH.sell).toFixed(3)
            },
            EUR: {
              buy: (1 / (USD.UAH.buy / USD.EUR.buy)).toFixed(3),
              sell: (1 / (USD.UAH.sell / USD.EUR.sell)).toFixed(3)
            }
          },
        })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
  },
};
